export default "__VITE_ASSET__DVYwMfXQ__"